var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 23.4,
    height: 23.4,
    rx: 7.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 23.4,
    height: 23.4,
    rx: 7.7,
    stroke: "#89CCFF",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0059 18.1673C11.8793 18.1673 11.7526 18.1206 11.6526 18.0206L7.60594 13.974C7.4126 13.7806 7.4126 13.4606 7.60594 13.2673C7.79927 13.074 8.11927 13.074 8.3126 13.2673L12.0059 16.9606L15.6993 13.2673C15.8926 13.074 16.2126 13.074 16.4059 13.2673C16.5993 13.4606 16.5993 13.7806 16.4059 13.974L12.3593 18.0206C12.2593 18.1206 12.1326 18.1673 12.0059 18.1673Z",
    fill: "#3A3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0533C11.7267 18.0533 11.5 17.8267 11.5 17.5533V6.33333C11.5 6.06 11.7267 5.83333 12 5.83333C12.2733 5.83333 12.5 6.06 12.5 6.33333V17.5533C12.5 17.8267 12.2733 18.0533 12 18.0533Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareArrow);
export default __webpack_public_path__ + "static/media/compare-arrow.66975b71605cdebfe82decfe32ba6819.svg";
export { ForwardRef as ReactComponent };